import { StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';
import { getRequest, postRequest } from './amplify/helpers';

const urlPrefix = '/studio-video';

export const createStudioVideo = async (body) => {
  try {
    return await postRequest({
      apiName: 'studio',
      path: '/video-generation/generate',
      options: {
        body,
      },
    });
  } catch (e) {
    console.error('Error in createStudioVideo:', e);
  }
};

export const createBulkStudioVideo = async (body) => {
  try {
    return await postRequest({
      apiName: 'studio',
      path: '/video-generation/generate/bulk',
      options: {
        body,
      },
    });
  } catch (e) {
    console.error('Error in createBulkStudioVideo:', e);
  }
};

export const updateStudioVideo = async (body) => {
  try {
    return await postRequest({
      apiName: 'studio',
      path: `${urlPrefix}/update`,
      options: {
        body,
      },
    });
  } catch (e) {
    console.error('Error in createStudioVideo:', e);
  }
};

export const deleteStudioVideo = async (body) => {
  try {
    return await postRequest({
      apiName: 'studio',
      path: `${urlPrefix}/delete`,
      options: {
        body,
      },
    });
  } catch (e) {
    console.error('Error in createStudioVideo:', e);
  }
};

export const createDraftStudioVideo = async (body) => {
  try {
    return await postRequest({
      apiName: 'studio',
      path: `${urlPrefix}/draft`,
      options: {
        body,
      },
    });
  } catch (e) {
    console.error('Error in createStudioVideo:', e);
  }
};

export const getStudioVideo = async (appKey: string, id: string) => {
  try {
    return await getRequest({
      apiName: 'studio',
      path: `${urlPrefix}/get`,
      options: {
        queryParams: {
          appKey,
          id,
        },
      },
    });
  } catch (e) {
    console.error('Error in getStudioVideo:', e);
  }
};

export const listStudioVideos = async (appKey: string): Promise<StudioVideo[]> => {
  try {
    const response = await getRequest({
      apiName: 'studio',
      path: `${urlPrefix}/list`,
      options: {
        queryParams: {
          appKey,
        },
      },
    });

    return response;
  } catch (e) {
    console.error('Error in listStudioVideos:', e);
    return [];
  }
};

export const audioPreview = async (text: string, elevenLabsVoiceId?: string) => {
  try {
    const response = await postRequest({
      apiName: 'studio',
      path: `${urlPrefix}/audio-preview`,
      options: {
        body: { text, elevenLabsVoiceId },
      },
    });

    return response.audioBase64;
  } catch (e) {
    console.error('Error in audioPreview:', e);
  }
};
